<div class="container-fluid title-holder">
    <div class="container p-4">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="text-center w-100">Our Services</h2>
            </div>  
        </div>
    </div>
</div>
<div class="container mt-5 mb-5">
    <div class="row">
        <div class="col-sm-12 our-services-text">
            <div class="row m-auto w-100">
                <p class="px-3 mb-0">Nepal Property Services (NEPROSE) has various services to offer to its users, visitors and the clients. The main services we have been providing are listed below.</p>
            </div>
        </div>
    </div>
</div>
<div class="background-blue">
    <div class="container mt-5 mb-5">
        <div class="row main-services pb-4">
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div class="card-image">
                    <mat-icon>how_to_reg</mat-icon>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div>
                    <h3 class="header">To Registered Users/Clients</h3>
                    <ul class="my-4">
                        <li>User Accounts</li>
                        <li>Property Advertisements</li>
                        <li>Property Appraisal Guide</li>
                        <li>Lease Contract*</li>
                        <li>Deed/Agreement*</li>
                        <li>Other Related Services*</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row main-services pt-4 bottom">
            <div class="col-lg-12 mt-3">
                <p>Our website offers various features to our online users and the visitors. Our site is user friendly and can be accessed via smart phones, tablets and computers from all around the world with an internet access.</p>
            </div>
        </div>
    </div>
</div>
<div class="background-red">
    <div class="container mt-5 mb-5">
        <div class="row main-services pb-4">
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div class="card-image">
                    <mat-icon>business</mat-icon>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div>
                    <h3 class="header">To Business Partners</h3>
                    <ul class="my-4">
                        <li>Business Advertisements</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row main-services pt-4 bottom">
            <div class="col-lg-12 mt-3">
                <p>Publish an advertisement of your business directly on neprose.com and drive traffic to your business today! Our advertisement plans have got you covered, whether you are a new business or an established business looking to gain more clients. Our prices are flexible and our ads reach thousands of people all over the world everyday.</p>
            </div>
        </div>
    </div>
</div>
<div class="background-blue">
    <div class="container mt-5 mb-5">
        <div class="row main-services pb-4">
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div class="card-image">
                    <mat-icon>people</mat-icon>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 row align-items-center justify-content-center">
                <div>
                    <h3 class="header">Direct Services To Clients</h3>
                    <ul class="my-4">
                        <li>Property Photo Shoot</li>
                        <li>Property Valuation</li>
                        <li>Property Insurance</li>
                        <li>Mortgage & Financing</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row main-services pt-4 bottom">
            <div class="col-lg-12 mt-3">
                <p>Our clients are important and so are their investments! We are always ready to help and assist our clients and users where they feel our need. We can personally visit their home, office, land and any type of the property to provide required on-site services.</p>
            </div>
        </div>
    </div>
</div>

<!-- <div class="background-blue">
    <div class="container">
        <div class="row mx-auto w-100 main-services">
            <div class="col-xs-12 ">
				<nav>
					<div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
						<a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">To Registered Users/Clients</a>
						<a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">To Business Partners</a>
						<a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Direct Services To Clients</a>
					</div>
				</nav>
				<div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
					<div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
						<ul class="my-4">
                            <li>User Accounts</li>
                            <li>Property Advertisements</li>
                            <li>Property Appraisal Guide</li>
                            <li>Lease Contract*</li>
                            <li>Deed/Agreement*</li>
                            <li>Other Related Services*</li>
                        </ul>
                        <hr />
                        <p>Our website offers various features to our online users and the visitors. Our site is user friendly and can be accessed via smart phones, tablets and computers from all around the world with an internet access.</p>
					</div>
					<div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
						<ul class="my-4">
                            <li>Business Advertisements</li>
                        </ul>
                        <hr />
                        <p>Publish an advertisement of your business directly on neprose.com and drive traffic to your business today! Our advertisement plans have got you covered, whether you are a new business or an established business looking to gain more clients. Our prices are flexible and our ads reach thousands of people all over the world everyday.</p>
					</div>
					<div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
						<ul class="my-4">
                            <li>Property Photo Shoot*</li>
                            <li>Property Valuation*</li>
                            <li>Property Insurance*</li>
                            <li>Mortgage & Financing*</li>
                        </ul>
                        <hr />
                        <p>Our clients are important and so are their investments! We are always ready to help and assist our clients and users where they feel our need. We can personally visit their home, office, land and any type of the property to provide required on-site services.</p>
					</div>
				</div>
			
			</div>
        </div>
    </div>
</div> -->
<div class="container mt-5 mb-5">
    <div class="row">
        <div class="col-sm-12 our-services-text">
            <div class="row m-auto w-100">
                <p class="px-3 mb-0">To learn more about our prices on property advertisements and business advertisements, please visit our Pricing Page by following <a [routerLink]="['/pricing']"><strong>this link</strong></a></p>
            </div>
        </div>
    </div>
</div>